import React from "react";

const ModalFooter = ({ children }) => {
    return <div className="Modal-footer">{children}</div>;
};

export default ModalFooter;
